import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Media from "../../../assets/images/auth-home/media.png";
import Poll from "../../../assets/images/auth-home/poll.png";
import Document from "../../../assets/images/auth-home/document.png";
import Blog from "../../../assets/images/auth-home/blog.png";
import Emoji from "../../../assets/images/auth-home/emoji.png";
import Attachment from "../../../assets/images/auth-home/attachment.png";
import Arrowback from "../../../assets/images/auth/arrow-back.png";
import PollPopup from "../Popups/poll";
import MediaPopup from "../Popups/media";
import DocumentPopup from "../Popups/doc";
import BlogPopup from "../Popups/blog";

class CreatepostMob extends Component {
  state = {
    post: "",
    media: "",
    showMedia: false,
    showPoll: false,
    showBlog: false,
    showDoc: false,
  };

  setMedia = (data) => {
    // console.log("setMedia", this.state.media);
    // for displaying the image
    var input = data;
    var reader = new FileReader();
    reader.onload = () => {
      var dataURL = reader.result;
      var output = document.getElementById("image");
      output.src = dataURL;
    };
    reader.readAsDataURL(input.files[0]);
  };

  handlePostSubmit = (e) => {
    e.preventDefault();
    this.props.closeModal();
  };

  render() {
    return (
      <React.Fragment>
        <form onSubmit={this.handlePostSubmit}>
          <div className="row pb-3 align-items-center">
            <div className="col-5">
              <img src={Arrowback} alt="" onClick={this.props.closeModal} />
            </div>
            <div
              className="col-7"
              style={{ color: "#181818", fontSize: 18, fontFamily: "Poppins" }}
            >
              Post
            </div>
          </div>
          <div
            className="p-2"
            style={{ border: "1px solid var(--border-color)", borderRadius: 10 }}
          >
            <div className="d-flex align-items-end justify-content-between">
              <div>
                <textarea
                  className="form-control th-auth-home-sugstn-form-control w-100"
                  placeholder="What's on your mind?"
                  rows={2}
                  name="post"
                  value={this.state.post}
                  onChange={(e) =>
                    this.setState({ [e.target.name]: e.target.value })
                  }
                />
                {/* selected media/file is displayed here inside box */}
                {this.state.media && (
                  <div style={{ width: 260, height: 156 }}>
                    <img
                      id="image"
                      src={this.state.media}
                      alt=""
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        display: "block",
                      }}
                    />
                  </div>
                )}
              </div>
              <div>
                <img
                  src={Emoji}
                  alt=""
                  className="mx-1"
                  style={{ cursor: "pointer" }}
                />
                <img src={Attachment} alt="" style={{ cursor: "pointer" }} />
              </div>
            </div>
          </div>
          <div className="row pt-1">
            <div className="text-center col-3">
              <img
                src={Media}
                alt=""
                style={{ cursor: "pointer" }}
                onClick={() => {
                  this.setState({ showMedia: true });
                }}
              />{" "}
              <p className="th-auth-home-crtpost-icon-text">Media</p>
            </div>
            <div className="text-center col-3">
              <img
                src={Poll}
                alt=""
                style={{ cursor: "pointer" }}
                onClick={() => {
                  this.setState({ showPoll: true, media: "" });
                }}
              />{" "}
              <p className="th-auth-home-crtpost-icon-text">Poll</p>
            </div>
            <div className="text-center col-3">
              <img
                src={Document}
                alt=""
                style={{ cursor: "pointer" }}
                onClick={() => {
                  this.setState({ showDoc: true });
                }}
              />{" "}
              <p className="th-auth-home-crtpost-icon-text">Document</p>
            </div>
            <div className="text-center col-3">
              <img
                src={Blog}
                alt=""
                style={{ cursor: "pointer" }}
                onClick={() => {
                  this.setState({ showBlog: true, media: "" });
                }}
              />{" "}
              <p className="th-auth-home-crtpost-icon-text">Blog</p>
            </div>
          </div>
          <div className="th-auth-home-crtpost-mob-btn-wrap">
            <button className="btn th-auth-home-crtpost-mob-btn" type="submit">
              Submit
            </button>
          </div>
        </form>
        {/* Modals and Popus */}
        <Modal
          show={this.state.showMedia}
          onHide={() => this.setState({ showMedia: false })}
          centered
          contentClassName="th-auth-verify-modal-content"
          dialogClassName="th-auth-verify-modal-dialog"
        >
          <Modal.Body>
            <MediaPopup
              closeModal={() => {
                this.setState({ showMedia: false });
              }}
              getMediaData={(data) => {
                this.setState({ media: data.files[0] });
                this.setMedia(data);
              }}
              width={this.props.width}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showPoll}
          onHide={() => this.setState({ showPoll: false })}
          centered
          contentClassName="th-auth-verify-modal-content"
          dialogClassName="th-auth-verify-modal-dialog"
        >
          <Modal.Body>
            <PollPopup
              closeModal={() => this.setState({ showPoll: false })}
              width={this.props.width}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showDoc}
          onHide={() => this.setState({ showDoc: false })}
          centered
          contentClassName="th-auth-verify-modal-content"
          dialogClassName="th-auth-verify-modal-dialog"
        >
          <Modal.Body>
            <DocumentPopup
              closeModal={() => this.setState({ showDoc: false })}
              getMediaData={(data) => {
                this.setState({ media: data.files[0] });
                this.setMedia(data);
              }}
              width={this.props.width}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showBlog}
          onHide={() => this.setState({ showBlog: false })}
          centered
          contentClassName="th-auth-verify-modal-content"
          dialogClassName="th-auth-verify-modal-dialog"
        >
          <Modal.Body>
            <BlogPopup
              closeModal={() => this.setState({ showBlog: false })}
              width={this.props.width}
            />
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

export default CreatepostMob;
